import React, { forwardRef, useRef, useImperativeHandle } from 'react'
import styled from 'styled-components'
import { useIntl } from 'react-intl'

import { useAuthenticationState } from '../../../../../contexts/AuthenticationContext'
import { userMenuMessages } from '../../../../../translations'
import { baseTiltifyUrl } from '../../../../../utils'
import { Button } from '../../../../Button'

const StyledButton = styled(Button)`
  display: flex;
  font-size: 0.8125rem !important;
  font-weight: normal !important;
  padding: 0.625rem 1.0625rem;
  border: none;
  color: ${({ theme }) => theme.textColor} !important;
`

export const FrontendUserProfile = forwardRef((props, ref) => {
  const { formatMessage } = useIntl()
  const { user } = useAuthenticationState()
  const localRef = useRef()
  useImperativeHandle(ref, () => localRef.current)

  const baseURL = baseTiltifyUrl()

  return (
    <StyledButton forwardedAs='a' href={`${baseURL}/@${user.slug}/profile`} ref={localRef}>
      {formatMessage(userMenuMessages.profile)}
    </StyledButton>
  )
})
